import { Fragment } from 'react';
import { rage } from '~/rage';
import { BgPlaceholder, PlaceholderType } from '~/components/ui/BgPlaceholder';
import { StyledGradient } from './Background.styled';

const Background = () => {
	return (
		<Fragment>
			{rage.config.isStub() && (
				<BgPlaceholder $type={PlaceholderType.Default} />
			)}
			<StyledGradient />
			<StyledGradient />
			<StyledGradient />
			<StyledGradient />
		</Fragment>
	);
};

export { Background };
